import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import { ItemPriceParameter, Priceparam, RfpDetails, UploadedFile } from '../vendor-panel/manage-rfp/rfp-list-detail/rfp-detail.model';
import { Questioner } from '../core-module/rfp/questioner.model';
import { ManageRfpService } from '../vendor-panel/manage-rfp/manage-rfp.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CentralColumnDefinitionsService } from '../shared/services/central-column-definitions.service';
import { formatDate } from '@angular/common';
import { Bom } from '../shared/model/bom.model';
import { param } from 'jquery';
declare var require: any;
const FileSaver = require('file-saver');
@Component({
  selector: 'app-rfp-details-link',
  templateUrl: './rfp-details-link.component.html',
  styleUrls: ['./rfp-details-link.component.scss']
})
export class RfpDetailsLinkComponent implements OnInit, OnDestroy {
  private timer: any;
  public formattedHours: string = '00';
  public formattedMinutes: any = '00';
  public formattedSeconds: any = '00';
  difference!: number;
  fromDate!:any;
  now: any;
  data: any = [];
  companyId!: any;
  vendorId!: any;
  rfpId!: any;
  rfpCat!: any;
  public rowData: any = [];
  public liveRfpData: any = [];
  private gridApi!: GridApi<any>;
  rowClass: string;
  startTime: any
  endTime: any
  vendorEmployees: any[] = [];
  productheader: any[] = [];
  bom: Bom = new Bom();
  itempriceparameter: ItemPriceParameter = new ItemPriceParameter();
  priceparam: Priceparam = new Priceparam();
  questioner: Questioner = new Questioner();
  fileDetails: any = { filePath: '', file: null };
  filename: any;
  rfpStartDate: any;
  rfpEndDate: any;
  dateDifference: any = {};
  formatedMinutes: any;
  formatedSeconds: any;
  ItemId: any;
  ItemCode: any;
  itemName: any;
  priceparamId: any;
  priceparamName: any;
  priceparamPrize: any;
  item_id: any;
  vendorCode: string | undefined;
  vendor_id: string | undefined;
  rfpCode: string | undefined;
  PriceAmount: any[] = [];
  totalAmount: any;
  item: any;
  totalPrice: any;
  additional_charges: any;
  prCode: any;
  companyBranchId: any;
  @ViewChild('days', { static: true }) days?: ElementRef;
  @ViewChild('hours', { static: true }) hours?: ElementRef;
  @ViewChild('minutes', { static: true }) minutes?: ElementRef;
  @ViewChild('seconds', { static: true }) seconds?: ElementRef;
  months: Array<string> = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  constructor(
    private manageRfpService: ManageRfpService,
    private toastr: ToastrService,
    private router: Router,
    public columnDefsService: CentralColumnDefinitionsService,
    private activeRoute: ActivatedRoute,
  ) {
    this.rowClass = 'rowClass';
    this.activeRoute.params.subscribe((param:Params) => {
      this.rfpId = param['id'];
      this.rfpCat = param['name'];
      
    })
    this.activeRoute.queryParamMap.subscribe((param: any) => {
      
    })
  }
  contact: RfpDetails = new RfpDetails();
  rfpFile: UploadedFile = new UploadedFile();

  ngOnInit(): void {
    this.bom.bomMapping = [{ assetCategories_id: 0, assetClass_id: 0, item_id: 0, quantity: 0, company_id: this.companyId }];
    this.questioner.questionerMapping = [{ correctAnswer: '', question: '', weightage: '' }]
    const storedData = localStorage.getItem('user_details') ?? "{}";
    const userDetails = JSON.parse(storedData);

    if (userDetails && userDetails.company_id) {
      this.companyId = userDetails.company_id;
      // this.vendorId = userDetails.vendor_id;
      this.contact.vendor_id = userDetails.vendor_id;
      this.contact.vendor_code = userDetails.vendorCode;
      this.contact.supplier_name = userDetails.supplierName;
      this.contact.supplierContactPerson_name = userDetails.supplierContactPersonName
    }
    this.data = {
      company_id: this.companyId,
      rfp_id: this.rfpId,
      rfpCategory: this.rfpCat,
      vendor_id: this.contact.vendor_id,
    }
    this.vendorRfpDetail();

    // this.updateTimer();
    this.dateFormate()
  }
  ngOnDestroy() {
    // Stop the timer when the component is destroyed
    clearInterval(this.timer);
  }

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  onPageSizeChanged() {
    var value = (document.getElementById('page-size') as HTMLInputElement)
      .value;
    this.gridApi.paginationSetPageSize(Number(value));
  }

  onFilterTextBoxChanged() {
    this.gridApi.setQuickFilter(
      (document.getElementById('filter-text-box') as HTMLInputElement).value
    );
  }

  addColumns(): void {
    const headersAndFields = [
      { headerName: 'Sr No.', field: '', valueGetter: 'node.rowIndex + 1' },
      { headerName: 'Company Name', field: 'tbl_company.company_name' },
      { headerName: 'RFP Type', field: 'rfpCategory' },
      {
        headerName: 'RFP Code', field: 'rfpCode'
      },
      {
        headerName: 'Start Date', field: 'rfpStartDate',

        cellRenderer: this.dateFormatter
      },
      {
        headerName: 'End Date', field: 'rfpEndDate',

        cellRenderer: this.dateFormatter
      },
    ];
    this.columnDefsService.generateColumns(headersAndFields);
  }

  onCellClicked(e: any) {
    if (e.colDef.field === "rfpCode") {
    }
  }

  filesend: any[] = []
  onFileChange(event: any, index: number) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const fileNameParts = file.name.split('.');
        const fileExtension = fileNameParts.length > 1 ? fileNameParts[fileNameParts.length - 1] : '';
        this.filesend.push({
          file: e.target.result,
          fileExtension: fileExtension
        });
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  }
  getStatusColor(status: string): string {
    switch (status) {
      case 'Live':
        return 'rgb(0, 128, 55)';
      case 'Closed':
        return 'rgb(255, 0, 0)';
      default:
        return '';
    }
  }
  dateFormatter(params: any) {
    const formattedDate = formatDate(params.value, 'dd-MM-yyyy', 'en-US');
    return formattedDate;
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }
  add() {
    this.rfpFile.vendorBiddingFiles.push('');
  }

  remove(index: number) {
    this.rfpFile.vendorBiddingFiles.splice(index, 1);
  }
  rfpData: any;
  extraData: any;
  vendorRfpDetail() {
    this.manageRfpService.vendorRfpDetail(this.data).subscribe((res: any) => {
      this.rfpData = res.body.prData;
      this.extraData = res.body.itemData;
      if (res && res.body && res.body.data) {
        this.liveRfpData = res.body.data[0];
        this.vendorEmployees = res.body.itemData;
        this.contact.itemPriceParameter = res.body.data.tbl_rfpItemMappings;

        this.productheader = res.body.data[0].tbl_rfpPriceParamMappings;

        let myTime = this.liveRfpData.rfpStartTime >= 12 ? "PM" : "AM"
        let endmyTime = this.liveRfpData.rfpEndTime >= 12 ? "PM" : "AM"
        this.endTime = endmyTime
        this.startTime = myTime

        this.rfpStartDate = this.liveRfpData.rfpStartDate;
        this.rfpEndDate = this.liveRfpData.rfpEndDate;
        // this.calculateDateDifference();
        // this.startCountdown();
        this.dateFormate()
      }
    })
  }

  totaChargesData: any;
  calculateItemTotal() {
    const sumOfCalculatedSums = this.vendorEmployees.reduce((acc, curr) => {
      return acc + (Number(curr.calculatedSum));
    }, 0);
    const total = sumOfCalculatedSums + (Number(this.contact.additional_charges));
    this.contact.total_charges = total;
    this.totaChargesData = total;
    return total;
  }

  calculateItemSum(item: any) {
    let sum = 0;
    for (const header of this.productheader) {
      const value = Number(item[header.priceParameterName]) || 0;
      sum += (item.mVP * value) / 100;
    }
    item.calculatedSum = sum + item.mVP;
  }

  generatePriceParams(item: any) {
    return this.productheader.map(priceParam => ({
      priceParam_id: priceParam.priceParameter_id.toString(),
      priceParam_name: priceParam.priceParameterName,
      priceParam_prize: item[priceParam.priceParameterName],
    }));
  }

  submit() {
    const itemPriceParameter = this.vendorEmployees?.map(item => {
      this.calculateItemSum(item);
      const priceParams = this.generatePriceParams(item);

      return {
        item_id: item.item_id,
        item_code: item.itemCode,
        item_name: item.itemName,
        itemAmount: item.calculatedSum,
        uom_id: this.extraData[0].uom_id,
        uomName: this.extraData[0].uomName,
        service_id: item.service_id,
        serviceName: item.serviceName,
        serviceCode: "fgffg54",
        // quantity: this.liveRfpData.tbl_rfpItemVendorMaps[0].tbl_rfpItemVendorMaps, 
        mVP: this.extraData[0].mVP,
        vendor_id: this.contact.vendor_id,
        vendorCode: this.contact.vendor_code,
        supplierName: this.contact.supplier_name,
        supplierContactPersonName: this.contact.supplierContactPerson_name,
        mailId: "amit@gmail.com",
        prCategoryStatus: this.rfpData[0]?.prCategoryStatus,
        totalAmount: this.rfpData[0]?.totalAmount,
        finalTotalAmount: this.rfpData[0]?.finalTotalAmount,
        vendorAmount: "400",
        company_id: this.companyId,
        prType: this.rfpData[0]?.prType,
        price_param: priceParams
      };
    });

    const payload = {
      itemPriceParameter: itemPriceParameter,
      company_id: this.companyId,
      rfp_id: this.rfpId,
      rfp_code: this.liveRfpData.rfpCode,
      vendor_id: this.contact.vendor_id,
      vendor_code: this.contact.vendor_code,
      vendorBiddingFiles: this.filesend,
      lead_time: this.contact.lead_time,
      credit_days: this.contact.credit_days,
      additional_charges: this.contact.additional_charges,
      remark: this.contact.remark,
      total_charges: this.calculateItemTotal(),
    };
    this.manageRfpService.rfpdetailCreate(payload).subscribe(
      (res: any) => {
        if (res && res.body && res.body.data) {
          // this.resetItem();
          this.toastr.success(res.body.message);
          this.router.navigate(['vendor/manage-rfp/rfp-detail']);
        }
      },
      (error) => {
        // Handle error if needed

      }
    );
  }

  resetItem() {
    this.contact = new RfpDetails(); // Assuming Item is the class for itemMaster
  }
  addRow() {
    this.bom.bomMapping?.push({ assetCategories_id: 0, assetClass_id: 0, item_id: 0, quantity: 0, company_id: this.companyId });
  }

  removeRow(index: number) {
    this.bom.bomMapping?.splice(index, 1);
  }
  addRow1() {
    this.questioner.questionerMapping?.push({ correctAnswer: '', question: '', weightage: '' });
  }

  removeRow1(index: number) {
    this.questioner.questionerMapping?.splice(index, 1);
  }
  onFileSelected(fileInput: File[] | any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      const file = fileInput.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.fileDetails.filePath = e.target.result;
      };
      reader.readAsDataURL(file);
      this.fileDetails.file = file;
    } else {
      this.fileDetails = { filePath: '', file: null };
    }
    this.filename = this.fileDetails.file.name;
  }

  downloadContact(e: any) {
    if (this.contact?.rfp_FileUpload) {
      const pdfUrl = this.contact.rfp_FileUpload;
      const pdfName = this.contact.rfp_FileUpload;
      FileSaver.saveAs(pdfUrl, pdfName);
    } else {
    }
  }


  private padWithZero(value: number): string {
    return value < 10 ? `0${value}` : value.toString();
  }

  
  currentTime: any;
  targetDate: any;
  targetTime: any;
  dateFormate() {
    this.targetDate = new Date(this.rfpEndDate);
    this.targetTime = this.targetDate.getTime(); 
    this.currentTime = `${this.months[this.targetDate.getMonth()]
      } ${this.targetDate.getDate()}, ${this.targetDate.getFullYear()}`;

  }
  ngAfterViewInit() {
    setInterval(() => {
      this.tickTock();
      this.difference = this.targetTime - this.now;
      this.difference = this.difference / (1000 * 60 * 60 * 24);
      
      if (this.days) {
        !isNaN(this.days.nativeElement.innerText)
          ? (this.days.nativeElement.innerText = Math.floor(this.difference))
          : (this.days.nativeElement.innerHTML = `<img src="https://i.gifer.com/VAyR.gif" />`);
      }
    }, 1000);
  }
  tickTock() {
    this.fromDate = new Date();
    this.now = this.fromDate.getTime();
    if (this.days && this.minutes && this.seconds && this.hours) {
      this.days.nativeElement.innerText = Math.floor(this.difference);
      this.hours.nativeElement.innerText = 23 - this.fromDate.getHours();
      this.minutes.nativeElement.innerText = 60 - this.fromDate.getMinutes();
      this.seconds.nativeElement.innerText = 60 - this.fromDate.getSeconds();
    }
  }
}
